// extracted by mini-css-extract-plugin
export default {"slickSlider":"clpc6y9w6"};